import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { AuthLayout } from '@/shared/components/AuthLayout';
import { Spinner } from '@/shared/components/nebi';

const Login = lazy(() => import('@/features/public/components/Login'));
const SignUp = lazy(() => import('@/features/public/components/SignUp'));
const RecoverPassword = lazy(() => import('@/features/public/components/RecoverPassword'));
const ResetPassword = lazy(() => import('@/features/public/components/ResetPassword'));

const lazyRoute = (path: string, element: React.ReactNode): RouteObject => ({
  path,
  element: <Suspense fallback={<Spinner />}>{element}</Suspense>,
});

export const authRoutes: RouteObject[] = [
  {
    element: <AuthLayout />,
    children: [
      lazyRoute('login', <Login />),
      lazyRoute('criarContaUsuario', <SignUp />),
      lazyRoute('recuperarSenha', <RecoverPassword />),
      lazyRoute('redefinirSenha', <ResetPassword />),
    ],
  },
];
